import type { Subscription } from "../../shared/money";
import { addMonths, addYears } from "../../worker/money";

export { addMonths, addYears };

/**
 * The first `count` charge dates of a subscription. Same math as the Worker
 * (imported from worker/money — pure functions, no Worker-only APIs), so the
 * schedule the dialog draws always matches the server's due list.
 */
export function occurrenceList(sub: Subscription, count: number): string[] {
  const out: string[] = [];
  for (let i = 0; i < count; i++) {
    out.push(
      sub.kind === "installment" || sub.cycle === "monthly"
        ? addMonths(sub.firstDate, i)
        : addYears(sub.firstDate, i),
    );
  }
  return out;
}
